// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.24.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Utility methods to access information on LiveWatch business hours
// -----------------------------------------------------------------------------

// Days
const SUN = 0
const MON = 1
const TUE = 2
const WED = 3
const THU = 4
const FRI = 5
const SAT = 6

// Hours
const MON_OPEN = 7
const MON_CLOSE = 23

const TUE_OPEN = 7
const TUE_CLOSE = 23

const WED_OPEN = 7
const WED_CLOSE = 23

const THU_OPEN = 7
const THU_CLOSE = 21

const FRI_OPEN = 7
const FRI_CLOSE = 21

const SAT_OPEN = 8
const SAT_CLOSE = 20

const SUN_OPEN = 9
const SUN_CLOSE = 20

// Timezone Offsets
const CDT_OFFSET = 5
const CST_OFFSET = 6

const HoursHelper = (() => {
  const centralTimeOffset = isDst() ? CDT_OFFSET : CST_OFFSET

  let HoursHelper = {
    get isOpen () {
      const hour = currentCTHour()

      switch (currentCTDay()) {
        case MON:
          return hour >= MON_OPEN && hour < MON_CLOSE
        case TUE:
          return hour >= TUE_OPEN && hour < TUE_CLOSE
        case WED:
          return hour >= WED_OPEN && hour < WED_CLOSE
        case THU:
          return hour >= THU_OPEN && hour < THU_CLOSE
        case FRI:
          return hour >= FRI_OPEN && hour < FRI_CLOSE
        case SAT:
          return hour >= SAT_OPEN && hour < SAT_CLOSE
        case SUN:
          return hour >= SUN_OPEN && hour < SUN_CLOSE
      }
    },

    get isClosedWeekend () {
      const hour = currentCTHour()

      switch (currentCTDay()) {
        case SAT:
        case SUN:
          return !this.isOpen
        case MON:
          return hour < MON_OPEN
        default:
          return false
      }
    }
  }

  function currentCTDate () {
    const now = new Date()
    now.setUTCHours(now.getUTCHours() - centralTimeOffset)

    return now
  }

  function currentCTDay () {
    return currentCTDate().getUTCDay()
  }

  function currentCTHour () {
    return currentCTDate().getUTCHours()
  }

  function isDst () {
    const JAN = 0
    const JUL = 6

    let date = new Date()
    let jan = new Date(date.getFullYear(), JAN, 1)
    let jul = new Date(date.getFullYear(), JUL, 1)
    let stdTimeOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())

    return date.getTimezoneOffset() < stdTimeOffset
  }

  return HoursHelper
})()

export default HoursHelper
